module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-ste-94e3937caac8cd89130ec0146641b2cd.png";